import {faEdit, faEye, faTrash} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Modal} from 'antd';

import {useLocale} from '../../../../provider/locale/locale-hook';
import {useDeleteYandexStory} from '../../../../service/yandex-stories/yandex-stories-hook';
import {YandexShortStoryType} from '../../../../service/yandex-stories/yandex-stories-type';

type StoryActionsPropsType = {
    story: YandexShortStoryType;
    onView: (storyId: number) => void;
    onEdit: (storyId: number) => void;
};

export function StoryActions({story, onView, onEdit}: StoryActionsPropsType): JSX.Element {
    const {getLocalizedString} = useLocale();
    const deleteStory = useDeleteYandexStory(story.name);

    function handleDelete(): void {
        Modal.confirm({
            title: getLocalizedString('YANDEX_STORY__CONFIRM__DELETE_STORY__TITLE'),
            content: getLocalizedString('YANDEX_STORY__CONFIRM__DELETE_STORY__DESCRIPTION'),
            okType: 'danger',
            onOk: () => deleteStory.mutate(story.id),
        });
    }

    return (
        <div style={{display: 'flex', gap: 4}}>
            <Button icon={<FontAwesomeIcon icon={faEye} />} onClick={() => onView(story.id)} size="small" type="text" />
            <Button
                icon={<FontAwesomeIcon icon={faEdit} />}
                onClick={() => onEdit(story.id)}
                size="small"
                type="text"
            />
            <Button
                danger
                icon={<FontAwesomeIcon icon={faTrash} />}
                loading={deleteStory.isLoading}
                onClick={handleDelete}
                size="small"
                type="text"
            />
        </div>
    );
}
